import { STATUS_META, STATUS_ORDER } from "./StatusBadge";
import { formatDate } from "@/lib/api";

export const OrderTimeline = ({ status, history = [] }) => {
  const currentIdx = STATUS_ORDER.indexOf(status);
  const cancelled = status === "cancelled";
  return (
    <ol className="relative pl-6">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-slate-200" />
      {STATUS_ORDER.map((s, i) => {
        const meta = STATUS_META[s];
        const Icon = meta.icon;
        const reached = !cancelled && i <= currentIdx;
        const active = !cancelled && i === currentIdx;
        const at = history.find((h) => h.status === s)?.at;
        return (
          <li key={s} className="flex items-start gap-4 py-3 relative">
            <div className={`relative z-10 w-4 h-4 rounded-full grid place-items-center mt-0.5 ${reached ? "bg-sky-600" : "bg-slate-300"}`}>
              {active && <span className="absolute -inset-1 rounded-full bg-sky-200 animate-ping" />}
              <Icon className="w-2.5 h-2.5 text-white" />
            </div>
            <div className="flex-1">
              <div className={`text-sm font-semibold ${reached ? "text-slate-900" : "text-slate-400"}`}>
                {meta.label}
              </div>
              {at && (
                <div className="text-xs text-slate-500">{formatDate(at)}</div>
              )}
            </div>
          </li>
        );
      })}
      {cancelled && (
        <li className="flex items-start gap-4 py-3">
          <div className="relative z-10 w-4 h-4 rounded-full bg-rose-500 mt-0.5" />
          <div className="text-sm font-semibold text-rose-700">Zrušeno</div>
        </li>
      )}
    </ol>
  );
};
